import { AfterViewInit, Component, ComponentFactoryResolver, Input, ViewChild } from "@angular/core";
import { AppService } from "@api";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { AlertaEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";
import { DxDataGridComponent } from "devextreme-angular";


@Component({
    selector: 'asignacionevaluaciontaller_alumno',
    templateUrl: './asignacionevaluaciontaller_alumno.component.html',
})

export class AsignacionEvaluacionTallerAlumnoComponent implements AfterViewInit{
    consulta!: boolean;
    @Input() identificador!: number;
    @Input() nivelid!: number;
    @Input() cicloid!: number;
    @Input() periodoevaluacionportipoevaluacionid!: number;
    @Input() periodoevaluacionid!: number;

    DataTaller: any[];
    selectedRows: any[];
    visualizador:boolean = false;


    @ViewChild(DxDataGridComponent, {static: false}) grid!: DxDataGridComponent;

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){
        this.DataTaller = [];
        this.selectedRows = [];
    }

    ngAfterViewInit() {
        if(this.identificador == 2){
            this.visualizador = true;
        }

    }

    onEditorPreparing(e: any) {
        let a = this.grid;
        let b = this.grid.instance;
    }

    SetTallerAlumno(){
        this.appService.Post("planeacion/asignacionevaluacion/taller/taller",{"cicloid":this.cicloid, "periodoevaluacionportipoevaluacionid":this.periodoevaluacionportipoevaluacionid}).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.DataTaller = res.data;
                this.SetTallerAlumnoBuscar();
            }
        })
    }

    onSelectionChanged(e: any) {
      const newlySelectedKeys = e.selectedRowKeys;
      const validSelectedKeys = newlySelectedKeys.filter((key: any) => {
        const rowData = e.component.getVisibleRows().find((row:any) => row.key === key)?.data;
        return !!rowData?.puestoid; // Solo si tiene puesto seleccionado
      });

      // Mostrar mensaje si trataron de seleccionar una fila sin puesto
      if (newlySelectedKeys.length > validSelectedKeys.length) {
        // Puedes usar un toast de DevExtreme o Angular
        this.mensajeService.Alerta(AlertaEnum.Warning,'Debes seleccionar un puesto antes de marcar esta fila.');
      }

      this.selectedRows = validSelectedKeys;
      e.component.selectRows(validSelectedKeys, false);
    }

    onPuestoSeleccionado(data: any) {
      const puestoSeleccionado = data.puestoid;

      // Si se eliminó el puesto (clear button), y la fila está seleccionada
      if (!puestoSeleccionado) {

        const index = this.selectedRows.findIndex(x => x.tallerextracurricularid == data.tallerextracurricularid);
        if (index !== -1) {
          this.selectedRows.splice(index, 1); // Quita del arreglo de seleccionados
        }
      }
    }

    getGridInstance() {
      return this.grid?.instance;
    }

    SetTallerAlumnoBuscar(){
        this.appService.Post("planeacion/asignacionevaluacion/taller/tallerbuscar",{"periodoevaluacionid":this.periodoevaluacionid,"nivelid":this.nivelid, "cicloid":this.cicloid, "periodoevaluacionportipoevaluacionid":this.periodoevaluacionportipoevaluacionid}).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                for(let valor of res.data){
                    let entidad = this.DataTaller.find(x=>x.tallerextracurricularid == valor.tallerextracurricularid);
                    if(entidad && this.identificador == 1){
                        entidad.puestoid = valor.puestoid;
                        this.selectedRows.push(entidad);
                    }else{
                        entidad.activo = true;
                    }
                }
            }
        })
    }

    Guardar(){
      this.appService.Post("planeacion/asignacionevaluacion/taller/tallerguardar",{"entidades":this.selectedRows,"periodoevaluacionid":this.periodoevaluacionid,"nivelid":this.nivelid, "cicloid":this.cicloid, "periodoevaluacionportipoevaluacionid":this.periodoevaluacionportipoevaluacionid}).then(res=>{
          if(res.status == RespuestaEstatusEnum.Success){
            this.mensajeService.Alerta(AlertaEnum.Success, res.message);
          }
      })
    }
}
